// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"85":"mobile","97":"desktop"}[chunkId] + "." + {"85":"b860d100","97":"cb233026"}[chunkId] + ".chunk.css";
};